<template>
    <div  style="background-color: #EBEEF9;position: absolute;top: 0;bottom: 0;left: 0;right: 0;">

		<div class="title" style="margin-top: 10px;padding: 10px;background-color: #ffffff;font-size:1.2rem;text-align: center;">查询结果</div>
		<div v-if="showError" style="background-color: #EBEEF9;margin-top: 25px;width: 94%;margin-left: 3%;text-align: center;">
		    <span style="color: red;">{{errmsg}}</span>
		</div>
		
		<div style="background-color: #ffffff;margin-top: 20px;width: 94%;margin-left: 3%;">
		    <div style="padding-top: 5px;text-align: center;">
		        <h2><span style="font-size: 20px;">{{ feeDetails.carNumber }}</span></h2>
		    </div>
		
		    <div class="info-item">
		        <label>停车场：</label>
		        <span>{{ feeDetails.parkName }}</span>
		    </div>
		
		    <div class="info-item">
	          <label>入场时间：</label>
	            <span>{{ feeDetails.enterTime }}</span>
		    </div>
		            
		    <div class="info-item">
	            <label>停车时长：</label>
		        <span>{{ feeDetails.parkingTime }}</span>
		    </div>
		
		    <div class="info-item">
	            <label>优惠金额：</label>
		        <span>{{ feeDetails.freePrice }} 元</span>
		    </div>
	        
		    <div class="info-item highlight">
	            <label>应付金额：</label>
		        <span style="color: red;font-size: 30px;"> {{ feeDetails.payPrice }} 元</span>
		    </div> 

		    
		</div>


		<div id="banner-wrapper" ref="banner-wrapper" style="display:none">
			<div id="image-banner"></div>
		</div>


        <el-button type="primary" style="width: 90%;height: 45px;font-size: 18px;margin-top: 15px;" @click='btnPay' :loading="payLoading" :disabled="btnDisabled">支付</el-button>

	</div>
</template>


<script>
import {post} from '../util/util'
import md5 from 'js-md5';

export default{
    data(){
        return{
			payLoading:false,

			btnDisabled:true,

			showError:false,
			errmsg:'',
			timer:null,

			resultInfo:null,
			authForm:null,

			feeDetails: {
			    parkName:'',
			    carNumber:'',
			    enterTime:'',
			    parkTime:0,
			    freePrice:0,
			    payPrice:0,
			    orderNo:'',
				parkingTime:''
			},
        }
    },
	computed:{
		FormatTime(){
			return function(len){
				let time='0时0分'
				if(len&&len>0){
					let hour= parseInt(len/3600)
					let min=parseInt((len%3600)/60)+1
					time=hour+'时'+min+'分'
				}
				return time
			}
		}
	},
    created(){
		this.resultInfo = JSON.parse(this.$route.params.info)
		let form= window.sessionStorage.getItem("ca_pay_authForm")
        if(form){
            this.authForm = JSON.parse(form)
        }
	},
    mounted(){
		if(this.resultInfo.head.status==="1"){
			this.feeDetails=this.resultInfo.body.data
			this.feeDetails.parkingTime=this.FormatTime(this.resultInfo.body.data.parkTime)
			this.feeDetails.payPrice=this.resultInfo.body.data.payPrice/100

			if(this.feeDetails.payPrice>0){
				this.btnDisabled=false//费用为0，禁止点击支付
				this.pullAdv(this.resultInfo.body.parkId)
			}

			this.feeDetails.freePrice=this.resultInfo.body.data.freePrice/100
			if(!this.resultInfo.body.data.carNumber&&this.resultInfo.body.data.nolicence){
				this.feeDetails.carNumber=this.resultInfo.body.data.nolicence
			}
			if(this.resultInfo.head.from){
				this.showError=true
				this.errmsg=this.resultInfo.head.message
			}
		}
		else{
			this.showError=true
			this.errmsg=this.resultInfo.head.message
		}

		if(this.resultInfo.body){
			this.feeDetails.parkName=this.resultInfo.body.parkName
		}
	},
    methods:{
		//拉起广告界面
		pullAdv(parkid){
			pyun.advertingPull({
				el: 'image-banner', // 必填，广告节点的 ID
				app_id: 'op53545147521db2f', // 必填
				openid: this.authForm.authCode, // 选填
				space_id: '869969967989137408', // 必填
				displayed: 1, // 必填，是否展示广告
				provider_code: parkid, 
				external: 1, 
				provider_url: 'https://parking.yundiankong.com/api/pp/requestadvmessage', // 必填，按照流量主信息同步接口文档实现
				personas: { 
					plate: this.feeDetails.carNumber, 
					trade_value: this.resultInfo.body.data.payPrice, 
				},
				success: (data) => {
					// 广告加载成功回调,显示弹窗
					document.getElementById('banner-wrapper').style.display = 'block';
				},
				failure: (cause) => {
					console.warn('广告加载失败:', cause);
				},
			});
		},

		//广告拦截
		btnPay(){
            this.payLoading=true
			let form={
				authCode:this.authForm.authCode,
				payOrder:this.resultInfo.body.payOrder
			}
			let sign= md5(JSON.stringify(form))
			form.sign=sign
			post("pp/createpayorder",form).then(res=>{
				if(res.head.status==="1"){
					if (pyun && typeof pyun.advertingIntercept == 'function') {
						pyun.advertingIntercept((event) => {
							if (event.action === 'REDIRECT') {
								// 用户确认购买
								let args = {
									depute_id: res.body.data.pay_id, 
									divert_provider: '42242366', 
									extra: {
										plate: this.feeDetails.carNumber, 
									}
								};
								event.redirect(args);
							} else 
								window.open(res.body.data.pay_url,'_self')
						});
					} else 
						window.open(res.body.data.pay_url,'_self')
				}else{
					this.$message.error(res.head.message)
				}
			})		
			this.payLoading=false
        },


    }
}
</script>


<style scoped>
.info-item {
  margin: 15px 0;
  padding: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;

}

.info-item label {
  color: #080808;
}


.info-item span {
  color: #666;
  font-size: small;
}
</style>